// import React, { useEffect, useState } from 'react';
// import ReactPaginate from 'react-paginate';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import { FaAssistiveListeningSystems } from 'react-icons/fa';
// import { AiOutlineDownload } from 'react-icons/ai';
// import moment from 'moment';


// const MobileBoyans = ({ setAudioData }) => {
//     let getBoyan = useSelector((state) => state.boyan.allboyan[0]);
//     const category = useSelector((state) => state.boyan.filter);
//     const subject = useSelector((state) => state.boyan.subject);
//     const month = useSelector((state) => state.boyan.month);

// const allboyan = getBoyan.map(obj => {
//     return { ...obj, date: obj.date.slice(-2) + " " + moment(moment(obj.date).format("YYYY/MM/DD")).format('MMMM') + " " + obj.date.slice(0, 4) };
// });


// const boyans = category === "all" ? allboyan : category === "subject" ? allboyan.filter(boyan => boyan.subject === subject) : category === "month" ? allboyan.filter(boyan => boyan.date.includes(month)) : allboyan.filter(boyan => boyan.category === category);

//     // const [loading, setLoading] = useState(true);
//     const [searchResult, setSearchResult] = useState([]);
//     const [isSearching, setIsSearching] = useState(false);

//     const [pageCount, setPageCount] = useState(0);
//     const [start, setStart] = useState(0);
//     const [end, setEnd] = useState(20);

//     useEffect(() => {
//         setPageCount(Math.ceil(boyans.length / 20));
//     }, [boyans.length])


//     const handleSearchResult = (event) => {
//         const searchText = event.target.value;
//         // const filtered = boyans.filter(boyan => boyan.name.includes(search))
//         const match = boyans.filter(boyan => boyan.name.includes(searchText));
//         setSearchResult(match);
//         // setPageCount(Math.ceil(match.length/5));
//         setIsSearching(true);
//     }

//     const handlePlayAudio = (boyan) => {
//         setAudioData(boyan);
//         const newView = boyan.view ? boyan.view : 0;
//         const view = parseInt(newView) + 1;
//         const viewCount = { view };

//         fetch(`https://madrumi.thakurgaonexpress.com/getboyans/${boyan?._id}`, {
//             method: 'PATCH',
//             headers: {
//                 'content-type': 'application/json'
//             },
//             body: JSON.stringify(viewCount)
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log(data);

//             })

//     }
//     const handleDownloadCount = (boyan) => {
//         const newDownload = boyan.download ? boyan.download : 0;
//         const download = parseInt(newDownload) + 1;
//         const downloadCount = { download };

//         fetch(`https://madrumi.thakurgaonexpress.com/getboyans/${boyan?._id}`, {
//             method: 'PATCH',
//             headers: {
//                 'content-type': 'application/json'
//             },
//             body: JSON.stringify(downloadCount)
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log(data);
//             })

//     }

//     let st = 0;
//     let en = 20;

//     const handlePageClick = (data) => {
//         if (data.selected + 1 < 3) {
//             st = st * data.selected + 1 * 20;
//         } else {
//             st = st * data.selected + 1 * 20 + 20;
//         }

//         if (data.selected + 1 <= 1) {
//             st = 0
//             en = 20
//         }
//         en = en * data.selected + 20;
//         setStart(st);
//         setEnd(en);
//         window.scrollTo(0, 0);
//     }

//     const reloadFn = () => {
//         setStart(st);
//         setEnd(en);
//     }

//     return (
//         <div data-aos="fade-right" className='w-10/12 lg:w-11/12 mx-auto mt-16 relative bg-gray-100 text-black'>
//             <h1 className='text-xl border-b-4 border-accent font-bold mt-8 inline-block'>মুফতি শফি সাহেব (দাঃ বাঃ) এর {category === "জুম'আর বয়ান" ? "জুম'আর সকল বয়ান" : category === "all" ? "সকল বয়ান সমূহ" :
//                 category === "জুম'আর পরের বয়ান" ? "জুম'আর পরের বয়ান" : category === "সাপ্তাহিক তরবিয়তি মজলিশ" ? "সাপ্তাহিক তরবিয়তি মজলিশের বয়ান" : category === "মাসিক ইজতেমার বয়ান" ? "মাসিক ইজতেমার বয়ান" : category === "মাহফিলের বয়ান" ? "বিভিন্ন মাহফিলের বয়ান" : subject + " বিষয়ে বয়ান"}</h1><br />
//             <div className='flex justify-center items-center my-4'>
//                 <div class="form-control w-80">
//                     <label class="label">
//                         <span class="label-text font-bold">বয়ানের বিষয় লিখে অনুসন্ধান করুন</span>
//                     </label>
//                     <input onMouseDown={reloadFn} onChange={handleSearchResult} type="text" placeholder="বয়ানের বিষয় লিখুন" class="input input-bordered bg-white input-accent w-full max-w-xs" />
//                 </div>
//             </div>

//             <hr />
//             <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5'>
//                 {
//                     isSearching ? searchResult.slice(start, end).map(boyan => <div style={{ height: '370px' }} className='shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative'>
//                         <h3 className='text-lg font-bold min-h-8'>বয়ানের বিষয়ঃ {boyan.name}</h3>
//                         <h3 className='text-base'><span className='font-bold'>স্থানঃ </span>{boyan.place}</h3>
//                         <h3 className='text-base'><span className='font-bold'>তারিখঃ</span> {boyan.date}  <span className='font-bold'>  বিভাগঃ</span> {boyan.category}</h3>
//                         <p className='my-4'>{boyan.description}</p>
//                         <div className='flex flex-row'>
//                             <FaAssistiveListeningSystems className='text-xs' />
//                             <p className='ml-px text-xs'>{boyan?.view}</p>
//                             <AiOutlineDownload className='text-xs ml-2' />
//                             <p className='ml-px text-xs'>{boyan?.download}</p>
//                         </div>
//                         {/* <audio className='w-11/12 mt-2 bg- absolute bottom-20 left-3' controls src={boyan.link}></audio> */}
//                         <div className='mt-4 text-center absolute bottom-6 rounded-2xl left-12 shadow-2xl p-2'>
//                             <label onClick={() => handlePlayAudio(boyan)} for="my-modal-6" class="btn btn-accent btn-circle text-white font-bold mr-12">শুনুন
//                             </label>
//                             <label onClick={() => handleDownloadCount(boyan)} for="my-modal-6" class="btn btn-accent text-white font-bold mr-2"><a href={boyan.link}>ডাউনলোড</a>
//                             </label>
//                         </div>
//                     </div>) : boyans.slice(start, end).map(boyan => <div style={{ height: '370px' }} className='shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative'>
//                         <h3 className='text-lg font-bold min-h-8'>বয়ানের বিষয়ঃ {boyan.name}</h3>
//                         <h3 className='text-base'><span className='font-bold'>স্থানঃ </span>{boyan.place}</h3>
//                         <h3 className='text-base'><span className='font-bold'>তারিখঃ</span> {boyan.date}  <span className='font-bold'>  বিভাগঃ</span> {boyan.category}</h3>
//                         <p className='my-4'>{boyan.description}</p>
//                         <div className='flex flex-row'>
//                             <FaAssistiveListeningSystems className='text-xs' />
//                             <p className='ml-px text-xs'>{boyan?.view}</p>
//                             <AiOutlineDownload className='text-xs ml-2' />
//                             <p className='ml-px text-xs'>{boyan?.download}</p>
//                         </div>
//                         {/* <audio className='w-11/12 mt-2 bg- absolute bottom-20 left-3' controls src={boyan.link}></audio> */}
//                         <div className='mt-4 text-center absolute bottom-6 rounded-2xl left-12 shadow-2xl p-2'>
//                             <label onClick={() => handlePlayAudio(boyan)} for="my-modal-6" class="btn btn-accent btn-circle text-white font-bold mr-12">শুনুন
//                             </label>
//                             <label onClick={() => handleDownloadCount(boyan)} for="my-modal-6" class="btn btn-accent text-white font-bold mr-2"><a href={boyan.link}>ডাউনলোড</a>
//                             </label>
//                         </div>
//                     </div>)
//                 }
//             </div>
//             <div className='mt-8 mb-20'>
//                 {boyans.length > 20 && <ReactPaginate
//                     previousLabel={'পূর্ববর্তী'}
//                     nextLabel={'পরবর্তী'}
//                     breakLabel={'...'}
//                     pageCount={pageCount}
//                     marginPagesDisplayed={3}
//                     pageRangeDisplayed={6}
//                     onPageChange={handlePageClick}
//                     containerClassName={'btn-group justify-center'}
//                     pageClassName={'btn btn-accent text-white'}
//                     activeClassName={'btn bg-white text-black'}
//                     previousClassName={'btn btn-accent text-white'}
//                     nextClassName={'btn btn-accent text-white'}
//                     breakClassName={'btn btn-accent text-white'}

//                 //    pageLinkClassName={'btn-link'}

//                 ></ReactPaginate>}
//             </div>

//         </div >
//     );
// };

// export default MobileBoyans;



//   const allboyan = getBoyan.map(obj => {
//         return { ...obj, date: obj.date.slice(-2) + " " + moment(moment(obj.date).format("YYYY/MM/DD")).format('MMMM') + " " + obj.date.slice(0, 4) };
//     });


// const boyans = category === "all" ? allboyan : category === "subject" ? allboyan.filter(boyan => boyan.subject === subject) : category === "month" ? allboyan.filter(boyan => boyan.date.includes(month)) : allboyan.filter(boyan => boyan.category === category);



import React, { useEffect, useState } from 'react';
import Loader from '../Shared/Loader';
import ReactPaginate from 'react-paginate';
import { FaAssistiveListeningSystems } from 'react-icons/fa';
import { AiOutlineDownload } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { openDB } from 'idb';
import { all } from 'axios';

const MobileBoyans = ({ setAudioData }) => {
    const [searchResult, setSearchResult] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [downloadProgress, setDownloadProgress] = useState({});
    const [downloadComplete, setDownloadComplete] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [boyans, setBoyans] = useState([]); // Store the boyans fetched from backend
    const [totalBoyans, setTotalBoyans] = useState(0); // Store total boyans from backend

    const limit = 10; // Number of boyans per page

    let allBoyan = useSelector((state) => state.boyan.allboyan[0]);
    const category = useSelector((state) => state.boyan.filter);
    const subject = useSelector((state) => state.boyan.subject);
    const month = useSelector((state) => state.boyan.month);





    console.log(subject, month, category);

    // Load downloaded files status from localStorage on component mount
    useEffect(() => {
        const downloadedFiles = JSON.parse(localStorage.getItem('downloadedFiles')) || {};
        setDownloadComplete(downloadedFiles);

        // Fetch boyans from backend initially
        fetchAnswersFromBackend(currentPage, "", category);
    }, [currentPage, category]); // Fetch boyans when the page or category changes

    // Fetch boyans from backend with pagination, search, and category filters
    // Fetch boyans from backend with pagination, search, and category filters
    // const fetchAnswersFromBackend = async (page = 1, search = "", category = "all") => {
    //     setIsLoading(true);
    //     try {
    //         // Normalize category to lowercase before sending to the backend
    //         const response = await fetch(`https://madrumi.thakurgaonexpress.com/getboyanswithfilter?page=${page}&limit=${limit}&search=${search}&category=${category.toLowerCase()}`);
    //         const data = await response.json();

    //         setBoyans(data.total); // Set boyans based on pagination
    //         setPageCount(Math.ceil(data.document / limit)); // Set total pages based on document count
    //         setTotalBoyans(data.document); // Store total boyans count
    //     } catch (error) {
    //         console.error("Error fetching boyans:", error);
    //     }
    //     setIsLoading(false);
    // };

    // Fetch boyans from backend with pagination, search, and category filters
    // const fetchAnswersFromBackend = async (page = 1, search = "", category = "all") => {
    //     setIsLoading(true);
    //     try {
    //         // Normalize category to lowercase before sending to the backend
    //         const response = await fetch(`https://madrumi.thakurgaonexpress.com/getboyanswithfilter?page=${page}&limit=${limit}&search=${search}&category=${category}&subject=${subject}&month=${month}`);
    //         const data = await response.json();

    //         setBoyans(data.total); // Set boyans based on pagination
    //         setPageCount(Math.ceil(data.document / limit)); // Set total pages based on document count
    //         setTotalBoyans(data.document); // Store total boyans count
    //     } catch (error) {
    //         console.error("Error fetching boyans:", error);
    //     }
    //     setIsLoading(false);
    // };


    const fetchAnswersFromBackend = async (page = 1, search = "", category = "all") => {
        setIsLoading(true);
        try {
            const response = await fetch(`https://madrumi.thakurgaonexpress.com/getboyanswithfilter?page=${page}&limit=${limit}&search=${search}&category=${category}&subject=${subject}&month=${month}`);
            const data = await response.json();

            setBoyans(data.total); // Set boyans based on pagination
            setPageCount(Math.ceil(data.document / limit)); // Set total pages based on document count
            setTotalBoyans(data.document); // Store total boyans count
        } catch (error) {
            console.error("Error fetching boyans:", error);
        }
        setIsLoading(false);
    };




    // Handle search input
    const handleSearchResult = (event) => {
        const searchText = event.target.value;
        setIsSearching(true);

        if (category === 'all') {
            // Fetch boyans from backend when category is "all"
            fetchAnswersFromBackend(1, searchText, category);
        } else {
            // Filter the current loaded boyans locally for other categories
            const filteredBoyans = allBoyan.filter(boyan =>
                boyan.category === category &&
                boyan.name.toLowerCase().includes(searchText.toLowerCase())
            );
            setBoyans(filteredBoyans);
        }
    };


    const handlePlayAudio = (boyan) => {
        setAudioData(boyan);
        const newView = boyan.view ? boyan.view : 0;
        const view = parseInt(newView) + 1;
        const viewCount = { view };

        fetch(`https://madrumi.thakurgaonexpress.com/getboyan/${boyan?._id}`, {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(viewCount)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
            });
    };


    // Handle Download and save to IndexedDB
    // Initialize IndexedDB
    const initDB = async () => {
        const db = await openDB('AudioDB', 1, {
            upgrade(db) {
                const store = db.createObjectStore('audioFiles', { keyPath: '_id' });
                store.createIndex('name', 'name', { unique: false });
            }
        });
        return db;
    };

    const handleDownloadAndSave = async (boyan) => {
        const db = await initDB();

        // Check if the file has already been downloaded
        if (downloadComplete[boyan._id]) {
            return;
        }

        const audioBlob = await fetchAudioFile(boyan.link, boyan._id); // Download audio file as Blob

        // Save Blob and question to IndexedDB with the required _id key
        await db.put('audioFiles', { blob: audioBlob, type: 'বয়ান', name: boyan.name }, boyan._id);

        const updatedDownloadComplete = { ...downloadComplete, [boyan._id]: true };
        setDownloadComplete(updatedDownloadComplete); // Mark the file as downloaded

        // Store updated status in localStorage
        localStorage.setItem('downloadedFiles', JSON.stringify(updatedDownloadComplete));

        handleDownloadCount(boyan);

        // Show success toast notification
        toast.success('File downloaded successfully!');
    };

    const fetchAudioFile = async (url, id) => {
        const response = await fetch(url);
        const reader = response.body.getReader();
        const contentLength = +response.headers.get('Content-Length');

        let receivedLength = 0; // Received length of data
        let chunks = []; // Array to hold the downloaded chunks

        while (true) {
            const { done, value } = await reader.read();

            if (done) break;

            chunks.push(value);
            receivedLength += value.length;

            // Calculate and set download progress for the specific file
            const progress = (receivedLength / contentLength) * 100;
            setDownloadProgress(prev => ({ ...prev, [id]: progress }));
        }

        // Create Blob from downloaded chunks
        const blob = new Blob(chunks);
        return blob;
    };

    const handleDownloadCount = (boyan) => {
        const newDownload = boyan.download ? boyan.download : 0;
        const download = parseInt(newDownload) + 1;
        const downloadCount = { download };

        fetch(`https://madrumi.thakurgaonexpress.com/getboyan/${boyan?._id}`, {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(downloadCount)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
            });
    };

    // Handle pagination page click
    const handlePageClick = (data) => {
        setCurrentPage(data.selected + 1); // Update the current page
        window.scrollTo(0, 0);
    };

    return (
        <div className='w-10/12 lg:w-11/12 mx-auto mt-16 relative'>
            <ToastContainer />
            <h1 className='text-xl border-b-4 border-accent font-bold mt-8 inline-block'>মুফতি শফি সাহেব (দাঃ বাঃ) এর {category === "জুম'আর বয়ান" ? "জুম'আর সকল বয়ান" : category === "all" ? "সকল বয়ান সমূহ" :
                category === "জুম'আর পরের বয়ান" ? "জুম'আর পরের বয়ান" : category === "সাপ্তাহিক তরবিয়তি মজলিশ" ? "সাপ্তাহিক তরবিয়তি মজলিশের বয়ান" : category === "মাসিক ইজতেমার বয়ান" ? "মাসিক ইজতেমার বয়ান" : category === "মাহফিলের বয়ান" ? "বিভিন্ন মাহফিলের বয়ান" : subject + " বিষয়ে বয়ান"}
            </h1><br />

            {/* Search Input */}
            <div className='flex justify-center items-center my-4'>
                <div className="form-control w-80">
                    <label className="label">
                        <span className="label-text font-bold">বয়ানের বিষয় লিখে অনুসন্ধান করুন</span>
                    </label>

                    <input onChange={handleSearchResult} type="text" placeholder="বয়ানের বিষয় লিখুন" class="input input-bordered bg-white input-accent w-full max-w-xs" />
                </div>
            </div>

            <hr />

            {/* Show Loader */}
            {isLoading ? (
                <Loader />
            ) : (
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5'>
                    {boyans?.length > 0 ? boyans.map(boyan => (
                        <div key={boyan._id} style={{ height: '370px' }} className='shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative'>
                            <h3 className='text-lg font-bold min-h-8'>বয়ানের বিষয়ঃ {boyan.name}</h3>
                            <h3 className='text-base'><span className='font-bold'>স্থানঃ </span>{boyan.place}</h3>
                            <h3 className='text-base'><span className='font-bold'>তারিখঃ</span> {boyan.date}  <span className='font-bold'>  বিভাগঃ</span> {boyan.category}</h3>
                            <p className='my-4'>{boyan.description}</p>
                            <div className='flex flex-row'>
                                <FaAssistiveListeningSystems className='text-xs' />
                                <p className='ml-px text-xs'>{boyan?.view}</p>
                                <AiOutlineDownload className='text-xs ml-2' />
                                <p className='ml-px text-xs'>{boyan?.download}</p>
                            </div>
                            <div className='mt-4 text-center absolute bottom-6 rounded-2xl left-12 shadow-2xl p-2'>
                                <label onClick={() => handlePlayAudio(boyan)} htmlFor="my-modal-6" className="btn btn-accent btn-circle text-white font-bold mr-12">শুনুন</label>
                                <label
                                    onClick={() => handleDownloadAndSave(boyan)}
                                    className={`btn ${downloadComplete[boyan._id] ? 'btn-gray text-gray-500 cursor-not-allowed' : 'btn-accent text-white font-bold'}`}
                                    disabled={downloadComplete[boyan._id]}
                                >
                                    {downloadComplete[boyan._id] ? 'ডাউনলোড হয়েছে' : 'ডাউনলোড'}
                                </label>
                            </div>
                            {downloadProgress[boyan._id] && downloadProgress[boyan._id] < 100 && (
                                <div className='progress' style={{ backgroundColor: '#f0f0f0', borderRadius: '8px', height: '10px', marginTop: '2px' }}>
                                    <div
                                        className='progress-bar'
                                        role='progressbar'
                                        style={{
                                            width: `${Math.max(downloadProgress[boyan._id], 1)}%`,
                                            backgroundColor: '#4caf50', // Set your preferred color here
                                            height: '100%',
                                            borderRadius: '8px',
                                            transition: 'width 0.5s ease' // Smooth transition
                                        }}
                                    >
                                        {Math.round(downloadProgress[boyan._id])}%
                                    </div>
                                </div>
                            )}
                        </div>
                    )) : <p>No boyans found</p>}
                </div>
            )}

            {/* Pagination */}
            <div className="flex justify-center mt-5 mb-20 flex-wrap">
                {pageCount > 0 && (
                    <ReactPaginate
                        previousLabel={<span className="text-gray-700">Previous</span>}
                        nextLabel={<span className="text-gray-700">Next</span>}
                        breakLabel={<span className="text-gray-700">...</span>}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"flex space-x-2 flex-wrap"}
                        pageClassName={"flex items-center justify-center bg-white border border-gray-300 hover:bg-gray-200 text-gray-700 font-medium py-1 px-2 rounded-md cursor-pointer"}
                        previousClassName={"flex items-center justify-center bg-gray-200 border border-gray-300 text-gray-700 font-medium py-1 px-2 rounded-md cursor-pointer"}
                        nextClassName={"flex items-center justify-center bg-gray-200 border border-gray-300 text-gray-700 font-medium py-1 px-2 rounded-md cursor-pointer"}
                        breakClassName={"flex items-center justify-center text-gray-700 font-medium py-1 px-2"}
                        activeClassName={"bg-accent text-white font-bold"}
                        disabledClassName={"bg-gray-300 text-gray-500 cursor-not-allowed"}
                    />
                )}
            </div>


        </div>
    );
};

export default MobileBoyans;